import { type ReactNode } from "react";
import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { XStack } from "tamagui";

import { useAuth } from "@/contexts/AuthContext";
import { useUnreadNotificationCount } from "@/hooks/useUnreadNotificationCount";

export function KindredLogoButton() {
  const navigate = useNavigate();
  const { user } = useAuth();

  return (
    <button
      type="button"
      onClick={() => navigate(user ? "/kinfeed" : "/")}
      className="flex h-10 w-10 shrink-0 items-center justify-center rounded-2xl border border-border/90 bg-white/90 p-1.5 shadow-sm transition hover:bg-white"
      aria-label={user ? "Go to Kinfeed" : "Go to Kindred home"}
    >
      <img src="/kindred-logo.png" alt="" className="h-full w-full object-contain" />
    </button>
  );
}

export function NotificationsButton({ unreadCount }: { unreadCount: number }) {
  const navigate = useNavigate();

  return (
    <button
      type="button"
      onClick={() => navigate("/notifications")}
      className="relative inline-flex h-10 w-10 shrink-0 items-center justify-center rounded-full border border-border bg-white/90 text-primary shadow-sm transition hover:bg-white"
      aria-label={unreadCount > 0 ? `${unreadCount} unread notifications` : "View notifications"}
    >
      <Bell size={18} />
      {unreadCount > 0 ? <span className="absolute right-2 top-2 h-2.5 w-2.5 rounded-full bg-accent" /> : null}
    </button>
  );
}

export function MemberHeaderActions({ children }: { children?: ReactNode }) {
  const { user } = useAuth();
  const unreadCount = useUnreadNotificationCount();

  if (!user) {
    return children ?? null;
  }

  return (
    <XStack alignItems="center" gap="$xs">
      {children}
      <NotificationsButton unreadCount={unreadCount} />
    </XStack>
  );
}
